import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { FeatureFlagGuardService } from 'src/app/services/core/feature-flag-guard.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ProfileRelatedInfoBean } from '../../beans/account/account-module.bean';
import { AnalyticsBean } from '../../beans/analytics/analytics-module.bean';
import { EheReport } from '../../beans/health-record/health-record.bean';
import { Config } from '../../config/config';
import { Environment } from '../../config/environment';
import { CATAPULT_REPORT, MAX_SSN_FAILURE_ATTEMPTS } from '../../constants/health-record.constants';
import { METHOD_TYPE } from '../../constants/service.constants';
import { USER_LEVEL } from '../../constants/user.level.constants';
import { DataCarrierService } from '../../services/core/data-carrier.service';
import { ServiceRouter } from '../../services/core/http-service-router.service';
import { ModalService } from '../../services/core/modal.service';
import { HealthRecordService } from '../../services/health-record/health-record.service';
import { EheAnalyticsDirective } from '../shared/ehe-analytics/ehe-analytics.directive';
import { SpinnerComponent } from '../shared/spinner/spinner.component';
import { RecordReleaseModalComponent } from './record-release-modal/record-release-modal.component';
import { RecordReleasePdf } from './record-release.type';
import { SsnVerificationModalComponent } from './ssn-verification-modal/ssn-verification-modal.component';
import { DateUtil } from 'src/app/utils/date.util';

@Component({
	selector: 'app-health-record',
	templateUrl: './health-record.component.html',
	styleUrls: ['./health-record.component.scss'],
	providers: [EheAnalyticsDirective],
})
export class HealthRecordComponent implements OnInit, OnDestroy {
	activeSection = 0;
	recordGroup = [];
	page = 1;
	totalPages: number;
	isLoaded = false;
	blob;
	pdfSrc: any;
	flag = false;
	subNavItems = [];
	noRecords = false;
	sortAscending = true;
	sortDescending = false;
	sortArr: any;
	years = new Set();
	data: any;
	activeSideMenu = 0;
	selectedIndex = 0;
	biometricNotEligible: boolean;
	sidebarMenu: Array<any> = [];
	recordReleaseList: Array<RecordReleasePdf> = [];

	USER_LEVEL = USER_LEVEL;
	currentUserPermission: string[] = [];

	showSsnVerificationModal: boolean;
	subscriptions: Subscription[] = [];
	biometricResult = [];
	isBiometricReport: boolean;
	analyticsData: AnalyticsBean;
	recordForSelectedYear = [];
	@Input() biometrics: boolean = false;
	@Input() profileRelatedInfo: ProfileRelatedInfoBean;
	catapultReport = CATAPULT_REPORT;

	constructor(
		private route: Router,
		private dialog: MatDialog,
		private serviceRouter: ServiceRouter,
		private config: Config,
		private modalService: ModalService,
		private environment: Environment,
		private spinner: SpinnerComponent,
		private dataCarrierService: DataCarrierService,
		private healthRecordService: HealthRecordService,
		public ffService: FeatureFlagGuardService,
		private eheAnalyticsDirective: EheAnalyticsDirective
	) {
		// this.features = this.ffService.
		this.activeSideMenu = 0;
		this.showSsnVerificationModal = false;
		this.biometricNotEligible = false;
		this.analyticsData = new AnalyticsBean();
		this.analyticsData.componentName = 'Other Documents';
		this.analyticsData.pageUrl = '/results';
	}

	ngOnInit() {
		this.activeSideMenu = 0;
		if (this.biometrics) {
			this.preProcessVerifySSN();
		} else {
			this.getEheRecords();
		}
		this.getRecordConsents();
	}

	preProcessVerifySSN() {
		this.profileRelatedInfo = this.dataCarrierService.getChannel().getValue().profile;
		if (this.profileRelatedInfo !== undefined && this.profileRelatedInfo.profileInfo.userMatched) {
			if (
				this.profileRelatedInfo.profileInfo.ssnVerificationRequired &&
				this.profileRelatedInfo.profileInfo.ssnFailureAttempts < MAX_SSN_FAILURE_ATTEMPTS
			) {
				this.showSsnVerificationModal = true;
				if (this.dialog.openDialogs.length === 0) {
					this.verifySsn();
				}
			} else if (this.profileRelatedInfo.profileInfo.ssnVerificationRequired === false) {
				this.getBiometricData();
			} else {
				this.biometricNotEligible = true;
			}
		}
	}

	getEheRecords() {
		this.data = [];
		this.recordGroup = [];
		this.spinner.startLoader();
		this.isBiometricReport = false;
		// call proxy service
		this.serviceRouter
			.makeRequest(
				this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
				this.config.url.healthRecord.getHealthDocuments,
				METHOD_TYPE.SECURED_GET,
				''
			)
			.subscribe(
				response => {
					this.spinner.stopLoader();
					this.preProcessData(response);
				},
				error => {
					this.spinner.stopLoader();
				}
			);
	}

	getRecordConsents() {
		this.healthRecordService.getRecordConsents().subscribe(
			response => {
				this.spinner.stopLoader();
				this.recordReleaseList = response;
			},
			error => {
				this.spinner.stopLoader();
			}
		);
	}

	preProcessData(response) {
		this.data = response.data;
		this.noRecords = false;
		this.biometricNotEligible = false;
		if (this.data.eheReports) {
			if (this.data.eheReports.length > 0) {
				this.years = new Set();
				this.data.eheReports.forEach(res => {
					this.years.add(this.getYear(res.contextDate));
				});
				this.sortDesc();
			} else {
				this.noRecords = true;
			}
		} else if (this.data.biometricReports) {
			if (this.data.biometricReports.length > 0) {
				this.years = new Set();
				this.data.biometricReports.forEach(res => {
					this.years.add(this.getYear(res.contextDate));
				});
				this.sortDesc();
			} else {
				this.noRecords = true;
			}
		}
	}

	populateReports(passedData) {
		this.recordGroup = [];
		passedData.forEach(year => {
			// this.sidebarMenu[0].subNavItems.push({ title: year });
			const report = new EheReport();
			report.year = year;
			report.report = [];
			if (this.data.eheReports) {
				this.data.eheReports.forEach(element => {
					if (year === this.getYear(element.contextDate)) {
						report.report.push(element);
					}
				});
			} else if (this.data.biometricReports) {
				this.data.biometricReports.forEach(element => {
					if (year === this.getYear(element.contextDate)) {
						report.report.push(element);
					}
				});
			}
			this.recordGroup.push(report);
		});
		// If there are more reports - wrapping the older reports
		if (this.recordGroup.length > 3) {
			const report = new EheReport();
			report.year = 'Older';
			report.report = [];
			const olderRecords = this.recordGroup.slice(4, this.recordGroup.length);
			olderRecords.forEach(record => {
				report.report = report.report.concat(record.report);
			});
			this.recordGroup = this.recordGroup.slice(0, 4);
			this.recordGroup.push(report);
		}
		this.getRecordForSelectedYear();
	}

	getRecordForSelectedYear() {
		this.recordForSelectedYear = [];
		if (this.recordGroup && this.recordGroup[this.activeSection]) {
			const year = this.recordGroup[this.activeSection].year;
			if (year) {
				const eheReport = this.recordGroup.find(record => record.year === year);
				this.recordForSelectedYear = eheReport.report;
			}
		}
	}

	getYear(date) {
		return DateUtil.getMoment(date).year();
	}

	getDate(date, format) {
		return moment(date).format(format);
	}

	openPDF(selectedDoc) {
		this.spinner.startLoader();
		if (selectedDoc.documentType === 'Consent') {
			this.route.navigate(['/wellness/health/record/view'], {
				queryParams: {
					consent: true,
					// epmsPID: selectedDoc.epmsPID,
					q: selectedDoc.reportUrl,
				},
			});
		} else if (selectedDoc.s3fileName) {
			this.route.navigate(['/wellness/health/record/view'], {
				queryParams: { froms3: true, q: selectedDoc.s3fileName },
			});
		} else if (this.isBiometricReport) {
			this.route.navigate(['/wellness/health/record/view'], {
				queryParams: { fromBiometrics: true, q: selectedDoc.id },
			});
		} else {
			this.route.navigate(['/wellness/health/record/view'], {
				queryParams: { fromBiometrics: false, q: selectedDoc.id },
			});
		}
	}

	getReportId(selectedDoc) {
		if (selectedDoc.documentType === 'Consent' || selectedDoc.s3fileName) {
			return selectedDoc.s3fileName;
		} else {
			return selectedDoc.id;
		}
	}

	releaseRecords() {
		const dialogRef = this.dialog.open(RecordReleaseModalComponent, {
			panelClass: 'record-release-dialog-panel',
			width: '100%',
			disableClose: true,
			data: {
				reports: this.recordGroup
			},
		});
		dialogRef.afterClosed().subscribe(() => {
			if (sessionStorage.getItem('submitRecordRelease')) {
				this.modalService.showSuccessToaster('Request for Medical Records Release successfully submitted');
				sessionStorage.removeItem('submitRecordRelease');
			}
		});
	}

	sortAsc() {
		this.sortAscending = true;
		this.sortDescending = false;
		this.sortArr = Array.from(this.years);
		const sortedAscPoints = this.sortArr.sort((a, b) => {
			return a - b;
		});
		this.populateReports(sortedAscPoints);
	}

	sortDesc() {
		this.sortAscending = false;
		this.sortDescending = true;
		this.sortArr = Array.from(this.years);

		const sortedDescPoints = this.sortArr.sort((a, b) => {
			return b - a;
		});
		this.populateReports(sortedDescPoints);
	}
	setActiveSection(index: number) {
		this.activeSection = index;
		this.getRecordForSelectedYear();
	}

	getSelectedIndex(index: number) {
		this.selectedIndex = index;
		this.setActiveSection(index);
	}

	verifySsn() {
		this.activeSideMenu = 1;
		const dialogRef = this.dialog.open(SsnVerificationModalComponent, {
			width: '500px',
			disableClose: true,
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result.ssnVerified) {
				this.showSsnVerificationModal = result.ssnVerified;
				this.getBiometricData();
				this.analyticsData.id = 'SSN Verified';
				this.analyticsData.redirectedTo = '/results';
				this.analyticsData.placement = 'Ssn Verification Modal';
				this.eheAnalyticsDirective.captureModalButtonData(this.analyticsData);
			} else {
				this.profileRelatedInfo.profileInfo.ssnFailureAttempts = result.attempts;
				this.biometricNotEligible = true;
			}
		});
	}

	getBiometricData() {
		this.spinner.startLoader();
		this.data = [];
		this.recordGroup = [];
		this.isBiometricReport = true;
		// call proxy service
		this.serviceRouter
			.makeRequest(
				this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
				this.config.url.healthRecord.getBiometricResults,
				METHOD_TYPE.SECURED_GET,
				''
			)
			.subscribe(
				response => {
					this.spinner.stopLoader();
					if (response.data && response.data.eheReports) {
						this.biometricResult = response.data.eheReports;
					}
					this.preProcessData(response);
				},
				error => {
					this.spinner.stopLoader();
				}
			);
		// this.preProcessData(bioMetricInfo);
	}

	setRecordActive() {
		this.activeSideMenu = 0;
		this.getEheRecords();
	}

	loadBiometricResult() {
		this.route
			.navigateByUrl('wellness/health/record/report', {
				skipLocationChange: true,
			})
			.then(() => this.route.navigate(['wellness/health/record/biometric/results']));
	}

	ngOnDestroy() {
		// prevent memory leak when component destroyed
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
		this.subscriptions = [];
	}
}
